import styled from 'styled-components';
import { Button } from './button';

export const ButtonLarge = styled(Button)`
  height: 64px;
  font-size: 22px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0 6px 10px 0 rgba(38, 156, 255, 0.3);
`;
